var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "file-manager-container" }, [
    _c("div", [
      _c(
        "form",
        {
          ref: "form",
          attrs: {
            action: _vm.urlService,
            method: "post",
            enctype: "application/x-www-form-urlencoded",
            name: "editFileOnline",
            target: "_blank",
          },
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "AccessToken" },
            domProps: { value: _vm.requestToken },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "AccessTokenTtl" },
            domProps: { value: _vm.requestTokenTtl },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "FileName" },
            domProps: { value: _vm.fileName },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "FileSize" },
            domProps: { value: _vm.fileSize },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "FileUrl" },
            domProps: { value: _vm.fileUrl },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "FileVersion" },
            domProps: { value: _vm.fileVersion },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "Action" },
            domProps: { value: _vm.fileAction },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "Application" },
            domProps: { value: _vm.applicationType },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "wopiUserId" },
            domProps: { value: _vm.idUser },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "OwnerId", value: "not-defined" },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "wopiUserName", value: "es-ES" },
          }),
          _c("input", {
            attrs: { type: "hidden", name: "wopiLocale", value: "es-ES" },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }